<template>
  <div class="footer_wrapper">
    <div class="footer_content">
      <div class="footer_column-left">
        <div class="top_row">
          <img class="footer_alk-logo" alt src="@/assets/img/alk-logo.svg"/>
        </div>
        <div class="bottom_row">
          <p class="footer-text"><span class="text-element"><nobr>Copyright ©2020.</nobr></span><span class="text-element"><nobr>All rights reserved.</nobr></span><span class="text-element"><nobr>ALK-Abelló, Inc.</nobr></span></p>
          <p class="footer-text pt-5"><span class="text-element code">US-ODA-2000037</span><span class="text-element">07/2020</span></p>
        </div>
      </div>
      <div class="footer_column-right">
        <img class="footer_product" alt src="@/assets/img/logo.svg"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapState(['userAgent', 'currentPage'])
  }
};
</script>

<style lang="scss">
.footer_wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 20px 0 0 0;

  .footer_content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    @include media("<tablet") {
      flex-direction: column;
    }

    .footer_column-left {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .footer_column-right {
      @include media("<tablet") {
        padding-top: 20px;
      }
    }
  }
}

.top_row {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
}

.bottom_row {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0 0 0;
}

.footer_alk-logo {
  width: 120px;
  height: 34px;
}

.footer_product {
  width: 120px;
  height: 95px;
  @include media("<=tablet") {
    width: 110px;
    height: 87px;
  }
}

.footer-text {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #000000;

  @include media("<=phone") {
    display: flex;
    flex-wrap: wrap;
  }

  @include media("<=410px") {
    &.pt-5 {
      padding-top: 0 !important;
    }
  }
}

.text-element {
  padding-right: 40px;
  @include media("<phone") {
    padding-right: 15px;
  }
}

.code {
  @include media("<=410px") {
    padding-right: 23px;
  }
}
</style>
